import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  formatDate,
  // getTimeFromStringInAmPm,
  formatNumber,
} from "../../../../common/Validations";

const PrintCommercialEvaluation = React.forwardRef((props, ref) => {
  const appConfig = useSelector((state) => state?.app?.appConfig);
  const { data } = props;

  const [quotationDocument, setQuotationDocument] = useState([]);
  const [rfxQuestions, setRfxQuestions] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const tableStyle = {
    border: "1px solid black",
    borderCollapse: "collapse",
    padding: "4px",
  };

  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };

  useEffect(() => {
    if (
      !isInitialized &&
      props?.data?.items?.length > 0 &&
      props?.data?.items[0]?.quotationDocument?.length > 0
    ) {
      setQuotationDocument(props?.data?.items[0]?.quotationDocument);
      setRfxQuestions(props?.data?.items);
      setIsInitialized(true);
    }
  }, [props, isInitialized]);

  return (
    <div ref={ref} style={printbody} className="m-4">
      <div style={tableStyle}>
        <Row>
          <Col
            lg={12}
            className="d-flex justify-content-between align-items-start pe-4 ps-4 mt-2"
          >
            <div>
              <img
                src={appConfig?.customerLogo1}
                alt="Customer Logo"
                className="introCustomerlogo"
              />
            </div>
            <div className="text-center flex-grow-1">
              <p className="fs-2 fw-bold m-0">
                {data?.companyCodeDesc}
              </p>
              <p className="fs-5 fw-bold m-0">
                #224, 17th 'C' Main, 4th Sector, H.S.R Layout, Bangalore - 560
                102.
              </p>
            </div>
            <div className="text-end">
              <span className="fw-bold me-2">Mob :</span>
              <p className="m-0">9448380669</p>
              <p className="m-0">7411677666</p>
            </div>
          </Col>

          <Col lg={12} className="fw-bold ms-4 mt-4">
            Number: {data?.documentNumber}
          </Col>

          <Col lg={12} className="fw-bold ms-4 mt-4">
            {/* <p className="me-2">Date:</p> */}
            <p>Date: {formatDate(data?.items[0]?.loadingDate)}</p>
          </Col>
          <Col lg={12} className="text-center mt-3">
            <p
              style={tableStyle}
              className="fs-5 fw-bold d-inline-block px-4 py-2"
            >
              Quotation Commercial Evaluation
            </p>
          </Col>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="tableHeader"></th>
                <th className="tableHeader"></th>
                {/* <th className="tableHeader"></th> */}
                <th className="tableHeader"></th>
                <th className="tableHeader"></th>
                <th className="tableHeader"></th>
                {quotationDocument?.map((supplier, index) => (
                  <th
                    className="tableHeader text-center"
                    colSpan={3}
                    key={index}
                  >
                    <span className="bg-table-status bg-table-new-status px-2">
                      {supplier.organisationName} - {supplier.quotationNr}
                    </span>
                  </th>
                ))}
              </tr>
              <tr>
                <th className="tableHeader _01">SL No</th>
                <th className="tableHeader _03">Indent Document</th>
                {/* <th className="tableHeader _03">Status</th> */}
                <th className="tableHeader _04">Material Code</th>
                <th className="tableHeader _04">Qty</th>
                <th className="tableHeader _04">Unit</th>
                {quotationDocument?.map((supplier, index) => (
                  <React.Fragment key={index + 1}>
                    <th className="tableHeader _04" style={{ width: "4%" }}>
                      Final Price
                    </th>
                    <th
                      colSpan={2}
                      className="tableHeader _04"
                      style={{ width: "4%" }}
                    >
                      Net Value
                    </th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {rfxQuestions?.map((question, index) => (
                <tr key={index + 1}>
                  <td className="_01" style={{ width: "1%" }}>
                    {question?.rfxItemNr || question?.local_id}
                  </td>
                  <td style={{ width: "1%" }}>{question?.documentNumber}</td>
                  <td style={{ width: "1%" }}>
                    <div
                      className="ellipsis"
                      title={question?.materialDescription}
                    >
                      <b>{question?.materialCode}</b> <br />
                      {question?.materialDescription}
                    </div>
                  </td>
                  <td style={{ width: "1%" }}>{question?.indentQuantity}</td>
                  <td style={{ width: "1%" }}>
                    {question?.orderUnitOfMeasure}
                  </td>
                  {question?.quotationDocument?.map(
                    (supplier, supplierIndex) => (
                      <React.Fragment key={supplierIndex}>
                        <td className="text-end">
                          {formatNumber(supplier?.quotationUnitPrice, "comma")}
                        </td>
                        <td
                          colSpan={2}
                          className="text-end fw-bold text-primary"
                        >
                          {formatNumber(supplier?.qtnitemValue, "comma")}
                        </td>
                      </React.Fragment>
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </table>

          {/* Footer */}
          <Row className="px-4">
            <Col xs={12} className="d-flex justify-content-end mt-4 fw-bold">
              <p>FOR {data?.companyCodeDesc}</p>
            </Col>
          </Row>
        </Row>
      </div>
    </div>
  );
});

export default PrintCommercialEvaluation;
